import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {useAppDispatch, useAppSelector} from "../hooks";
import {removeMember, selectMembers} from "../redux/members";
import {selectUser} from "../redux/auth";
import useApi from "../api/useApi";

export const useDelUserCommand = (): ICommand => {
  const messages = useMessageLogic()
  const user = useAppSelector(selectUser)
  const api = useApi()
  const members = useAppSelector(selectMembers)
  const dispatch = useAppDispatch()

  return {
    secure: true,

    help(): string {
      return '- deluser [USERNAME]\t\t\t:: removes a member from the system';
    },

    async process(msg: string): Promise<void> {
      if (!user) {
        return
      }

      if (!user?.defaultSystemId) {
        messages.addErrorMessage('add system.name before adding members')
        return
      }

      const memberName = msg.substring('deluser '.length).trim()
      if (memberName !== '') {
        const member = members.find((m) => m.name === memberName)
        if (member) {
          await api.members.removeMember(member.id)
          dispatch(removeMember(member.id))
          messages.addSuccessMessage( `removed member '${memberName}'`)
        } else {
          messages.addErrorMessage(`no member named '${memberName}'`)
        }
      } else {
        messages.addErrorMessage('no member name provided')
      }
    },

    matches(msg: string): boolean {
      return msg.toLowerCase().trim().startsWith('deluser ')
    }
  };
}